window.k1Forms = {
	setError: function (input, error = false) {
		let parent = input.closest('.default-form-input-text');
		let checkbox = input.getAttribute('name') === 'form-confirm' ?? false;
		let type = input.type;
		let id, label;
		// console.log(input.closest(".order-info__user-input"))
		if (input.closest(".order-info__user-input")) return false;
		if (checkbox) {
			id = input.getAttribute('id');
			label = document.querySelector(`label[for='${id}']`);
		}
		if (error) {
			switch (type) {
				case 'text':
					parent.classList.add('k1-error');
					break;
				case 'checkbox':
					label.classList.add('k1-error');
					break;
			}
		} else {
			switch (type) {
				case 'text':
					parent.classList.remove('k1-error');
					break;
				case 'checkbox':
					label.classList.remove('k1-error');
					break;
			}
		}
	},

	focusInput: function () {
		let inputs = document.querySelectorAll('.default-form-input-text-js input');
		if (!inputs) return false;
		inputs.forEach(input => {
			input.addEventListener('focus', () => {
				let parent = input.closest('.default-form-input-text');
				parent.classList.add('k1-focus')
			})
		})
	},

	focusTextarea: function () {
		let inputs = document.querySelectorAll('.default-form-textarea-js textarea');
		if (!inputs) return false;
		inputs.forEach(input => {
			input.addEventListener('focus', () => {
				let parent = input.closest('.default-form-textarea-js');
				parent.classList.add('k1-focus')
			})
		})
	},

	blurTextarea: function () {
		let inputs = document.querySelectorAll('.default-form-textarea-js textarea');
		if (!inputs) return false;

		inputs.forEach(input => {

			input.addEventListener('blur', () => {
				let parent = input.closest('.default-form-textarea-js');
				// if (input.getAttribute('id') === 'fast-buy-form-phone') {
				// 	if (!window.k1Forms.validatePhone(input.getAttribute('id'))) {
				// 		window.k1Forms.setError(input, true);
				// 		return false;
				// 	} else {
				// 		window.k1Forms.setError(input, false);
				// 		parent.classList.remove('k1-focus');
				// 		return true;
				// 	}
				// } else {
				parent.classList.remove('k1-focus');
				// }

				return true;
			})
		});
		return true;
	},

	blurInput: function () {
		let inputs = document.querySelectorAll('.default-form-input-text-js input')
		if (!inputs) return false;

		inputs.forEach(input => {

			input.addEventListener('blur', () => {
				let parent = input.closest('.default-form-input-text');

				switch (input.getAttribute("id")) {
					case "fast-buy-form-phone": {
						if (!window.k1Forms.validatePhone(input.getAttribute('id'))) {
							window.k1Forms.setError(input, true);
							return false;
						} else {
							window.k1Forms.setError(input, false);
							parent.classList.remove('k1-focus');
							return true;
						}
						// break;
					}
					case "fast-buy-form-name": {

						if (input.value.length) {
							window.k1Forms.setError(input, false);
							parent.classList.remove('k1-focus');
							return false;
						} else {
							window.k1Forms.setError(input, true);
							return true;
						}
						// break;
					}
					default: {
						parent.classList.remove('k1-focus');
						break;
					}
				}


				// if (input.getAttribute('id') === 'fast-buy-form-phone') {
				// 	if (!window.k1Forms.validatePhone(input.getAttribute('id'))) {
				// 		window.k1Forms.setError(input, true);
				// 		return false;
				// 	} else {
				// 		window.k1Forms.setError(input, false);
				// 		parent.classList.remove('k1-focus');
				// 		return true;
				// 	}
				// } else {
				// 	parent.classList.remove('k1-focus');
				// }

				return true;
			})
		});
		return true;
	},

	validatePhone: function (elemId) {
		let phone = document.getElementById(elemId);

		if (!phone.value) {
			return false;
		}
		let regex = /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;
		return regex.test(phone.value);
	},

	checkConfirm: function () {
		return document.querySelector('.fast-buy-form__confirm input').checked;
	},

	getDataFastBuyModal: function (event) {
		event.preventDefault();
		const fastBuyModal = document.querySelector('.modal-fast-buy-js');
		let fastBuyModalForm = document.querySelector('.fast-buy-form-js');
		let err = false;

		if (!fastBuyModalForm) err = true;
		if (fastBuyModalForm.querySelector('#fast-buy-form-name').value.length < 2) {
			window.k1Forms.setError(fastBuyModalForm.querySelector('#fast-buy-form-name'), true);
			err = true;
		}

		if (!window.k1Forms.validatePhone('fast-buy-form-phone')) {
			window.k1Forms.setError(fastBuyModalForm.querySelector('#fast-buy-form-phone'), true);
			err = true;
		}
		if (!window.k1Forms.checkConfirm()) {
			window.k1Forms.setError(document.querySelector('.fast-buy-form__confirm input'), true);
			err = true
		};
		if (err) return false;

		let formData = {};
		formData.name = fastBuyModalForm.querySelector('#fast-buy-form-name').value;
		formData.phone = fastBuyModalForm.querySelector('#fast-buy-form-phone').value;
		formData.productName = this.getProductName(fastBuyModal);
		formData.productID = this.getProductID(fastBuyModal);
		formData.currentSKU = this.getProductSKUValue(fastBuyModal);
		formData.price = this.getProductCurrentPrice(fastBuyModal);
		formData.oldPrice = this.getProductOldPrice(fastBuyModal) ?? '0';
		if (fastBuyModal.querySelector('.fast-buy-item__discount')) {
			formData.discount = this.getProductDiscount(fastBuyModal);
		}

		return formData;
	},

	getProductSKUValue: function (modal) {
		return modal.querySelector('.good-element__sku-title').textContent
	},

	getProductCurrentPrice: function (modal) {
		return modal.querySelector('.good-element__price-current').textContent
	},

	getProductOldPrice: function (modal) {
		return modal.querySelector('.good-element__price-old').textContent
	},

	getProductName: function (modal) {
		return modal.querySelector('.fast-buy-item__name').textContent
	},

	getProductDiscount: function (modal) {
		return modal.querySelector('.fast-buy-item__discount').textContent
	},

	getProductID: function (modal) {
		let id = null;
		const skuId = document.querySelector(".k1-sku-block-js").getAttribute("data-current-sku");
		if (skuId && skuId !== "") {
			id = skuId
		} else {
			id = modal.querySelector('.fast-buy-item__name').getAttribute('data-product-id')
		}
		return id;
	},

	getCallBackModalData: function () {
		let data = {}, error = false, fields = document.querySelectorAll(".page-form .form-action__row input");
		fields.forEach(field => {
			const name = field.getAttribute("name");
			const bitrixName = field.getAttribute("data-id");
			const value = field.value;
			if (name === "email") {
				if (window.k1ValidateForm.validateEmail(value)) {
					this.setError(field, false);
					data[bitrixName] = value;
				} else {
					this.setError(field, true);
					error = true;
				}
			}

			if (name === "name") {
				if (!value || value === "" || !!Number(value)) {
					this.setError(field, true);
					error = true;
				} else {
					this.setError(field, false);
					data[bitrixName] = value;
					error = false;
				}
			}

			if (name === "phone") {
				if (value === "") {
					this.setError(field, true);
					error = true
				} else {
					this.setError(field, false);
					data[bitrixName] = value;
					error = false
				}
			}
			// data[field.getAttribute("name")] = field.value
		});

		// data[bitrixName] = value;

		data["K1_CALLBACK_MESSAGE"] = document.querySelector(".page-form .form-action__row textarea").value;
		if (!error) return data;
	},

	getSearchInputValue: function () {
		return document.querySelector('#title-search-input').value;
	},

	disableSearchButton: function () {
		const searchButton = document.querySelector('.header__search-button input');
		if (this.getSearchInputValue()) {
			searchButton.removeAttribute('disabled')
		} else {
			searchButton.setAttribute('disabled', 'disabled')
		}
	},

	init: function () {
		this.focusInput();
		this.focusTextarea();
		this.blurInput();
		this.blurTextarea();
		this.disableSearchButton()
	}
};



window.addEventListener('DOMContentLoaded', function () {
	window.k1Forms.init();
});

document.querySelector('#title-search-input').addEventListener('input', function () {
	window.k1Forms.disableSearchButton();
});